// extracted by mini-css-extract-plugin
module.exports = {"root":"Paywall_root__ciuNi","slideDown":"Paywall_slideDown__QKcYJ","slideUp":"Paywall_slideUp__WKxZ0"};